"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brezzo-di-bedero": {
    "97ed4e5a": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "skipSearch": false
    }],
    "alcio": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e7f7c14f": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "skipSearch": false
    }],
    "ca-bianca": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "20cb3b4d": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "skipSearch": false
    }],
    "casa-fioroli": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3b626b77": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "skipSearch": false
    }],
    "casa-passera": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c6c5a71f": [{
      "hkey": "fbb33fb1",
      "slug": "sirpo-ameno",
      "name": "Sirpo Ameno",
      "primary": true,
      "skipSearch": false
    }],
    "casa-sirpo": [{
      "hkey": "fbb33fb1",
      "slug": "sirpo-ameno",
      "name": "Sirpo Ameno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "83753630": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "skipSearch": false
    }],
    "casa-spozio": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "513355d2": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "skipSearch": false
    }],
    "la-canonica": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a15f74d7": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "skipSearch": false
    }],
    "nonedo": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e1db9ec": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "skipSearch": false
    }],
    "pralongo": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8a87a664": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "skipSearch": false
    }],
    "trigo": [{
      "hkey": "45467f5d",
      "slug": "brezzo-di-bedero",
      "name": "Brezzo di Bedero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;